export default "__VITE_ASSET__DRXWgXeK__"